EmailFormTextInputView = require "../../common/views/text_input_view"

class EmailFormIntlTextParagraphInputView extends EmailFormTextInputView
  tagName: 'li'

  events:
    'keyup .text_paragraph_input': 'validateEmailForm'

  initialize: ->
    EmailFormTextInputView::initialize.apply(this, arguments)
    @elementID = ".text_paragraph_input"
    @template = {text_paragraph_input_template: true}

module.exports = EmailFormIntlTextParagraphInputView
